function dynamicSortMultiple() {
    let props = []
    const args = arguments
    /*Let's separate property name from ascendant or descendant keyword*/
    for (let i = 0; i < args.length; i++) {
        let splittedArg = args[i].split(/ +/)
        props[props.length] = [splittedArg[0], (splittedArg[1] ? splittedArg[1].toUpperCase() : "ASC")]
    }
    return (obj1, obj2) => {
        let i = 0, result = 0, numberOfProperties = props.length
        /*Cycle on values until find a difference!*/
        while (result === 0 && i < numberOfProperties) {
            result = dynamicSort(props[i][0], props[i][1])(obj1, obj2)
            i++
        }
        return result
    }
}

/*Base function returning -1,1,0 for custom sorting*/
const dynamicSort = (property, isAscDesc) => {
    return (obj1, obj2) => {
        if (isAscDesc === "DESC") {
            return ((obj1[property] > obj2[property]) ? (-1) : ((obj1[property] < obj2[property]) ? (1) : (0)))
        }
        return ((obj1[property] > obj2[property]) ? (1) : ((obj1[property] < obj2[property]) ? (-1) : (0)))
    }
}

const convertirAMiles = input => {
    let num = input.toString().replace(/\./g, '')
    if (!isNaN(num) && num.length > 3) {
        num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1,')
        num = num.split('').reverse().join('').replace(/^[.]/, '')
        return num
    }
    return input
}

// eslint-disable-next-line
const validMailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

export { dynamicSort, dynamicSortMultiple, convertirAMiles, validMailRE }
